import 'videojs-watermark';

import logo from '../assets/bnnvara-logo';

export default {
  mapPropStateToOptions: (props) => ({
    image: logo,
    position: props.type === 'video' ? 'top-left' : 'bottom-right',
    fadeTime: 2000,
    url: 'https://www.bnnvara.nl/wijzijnvoor-jijook',
  }),
};
